import React from "react";
import { Link } from "react-router-dom";
import Comingsoon from "./Coming";
import Handtools from "./Hand-tols"

const StructuralFramework = () => {

  return (
    <div className="flex flex-col md:flex-row bg-[#0c2341] text-white">
      <main>
        {/* AKT TOOLS - Text Content */}
        <div className="lg:col-span-5 bg-white text-[#0c2340] p-6 mt-4 rounded-lg duration-300 ease-in-out flex flex-col justify-center md:h-[300px]">
          <h2 className="text-2xl md:text-4xl font-bold mb-2  text-center">
            AKT TOOLS
          </h2>
          <p className="text-sm md:text-lg md:mt-1 mb-6 text-justify">
            AKT Powertools & Hand Tools are crafted to deliver exceptional performance for both professionals and DIY enthusiasts. The brand is renowned for its rugged durability, ergonomic design, and high precision across a wide variety of applications. From digital power supplies and nail guns to essential hand tools, AKT offers solutions for electrical, mechanical, and construction tasks with ease. Each tool is engineered with user convenience in mind, promoting safe and efficient operation. Whether you're on a job site or working on a home project, AKT tools provide the reliability and versatility you need. Built to last and designed to perform, they are a trusted companion in every toolkit.
            Wide product range includes electric drills, grinders, screwdrivers, and more
            Backed by consistent innovation and strict quality control standards
          </p>
        </div>
        {/*AKT TOOLS MAIN SECTION */}
        <h1 className="text-base md:text-2xl md:mb-3 py-2">
          <Link to="/">Home</Link> / AKT TOOLS DIVISION /{" "}
          <span className="font-bold">AKT TOOLS</span>
        </h1>

        <h1 className="text-2xl md:text-4xl font-bold">
          POWER TOOLS
        </h1>

        <div>
          <Comingsoon />
        </div>
        <h1 className="text-2xl md:text-4xl font-bold">
          HAND TOOLS
        </h1>
        <div>
          <Handtools />
        </div>
      </main>
    </div>
  );
};

export default StructuralFramework;
